/* Great Spirit — Iron Restore PDP sections. Loaded once (defer); safe to include from several sections. */
(function () {
  if (window.__gsPdp) return;
  window.__gsPdp = true;

  /* ---------- UGC video: plays inside its card (no pop-up) ---------- */
  var gsWatch = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.intersectionRatio < 0.3) {
        var v = en.target.querySelector('video.gs-ugc__player');
        if (v && !v.paused) v.pause();
      }
    });
  }, { threshold: [0, 0.3] }) : null;

  function stopVideo(card) {
    var m = card.querySelector('.gs-ugc__player');
    if (m) { if (m.pause) m.pause(); m.remove(); }
    card.classList.remove('is-playing');
    if (gsWatch) gsWatch.unobserve(card);
  }

  function playVideo(card) {
    if (card.classList.contains('is-playing')) return;
    document.querySelectorAll('.gs-ugc__card.is-playing').forEach(function (c) { stopVideo(c); });
    var embed = card.getAttribute('data-video-embed');
    var media;
    if (embed) {
      var parts = embed.split(':');
      media = document.createElement('iframe');
      media.src = parts[0] === 'youtube'
        ? 'https://www.youtube.com/embed/' + parts[1] + '?autoplay=1&rel=0&playsinline=1'
        : 'https://player.vimeo.com/video/' + parts[1] + '?autoplay=1';
      media.setAttribute('allow', 'autoplay; fullscreen');
      media.setAttribute('allowfullscreen', '');
    } else {
      media = document.createElement('video');
      media.src = card.getAttribute('data-video');
      media.controls = true;
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      var cover = card.querySelector('img');
      if (cover) media.poster = cover.currentSrc || cover.src;
      media.addEventListener('ended', function () { stopVideo(card); });
    }
    media.className = 'gs-ugc__player';
    card.appendChild(media);
    card.classList.add('is-playing');
    if (gsWatch) gsWatch.observe(card);
    if (media.play) { var p = media.play(); if (p && p.catch) p.catch(function () {}); }
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.gs-ugc__card[data-video]');
    if (card) playVideo(card);
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.gs-ugc__card[data-video]')) {
      e.preventDefault(); playVideo(e.target);
    }
  });

  /* ---------- "Make the switch" → scroll to the main product form ---------- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-gs-scroll-to-buy]');
    if (!link) return;
    var target = document.querySelector('[data-ss]') || document.querySelector('form[action*="/cart/add"]:not([data-gs-bundle])');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- Bundle & save ---------- */
  function initBundle(form) {
    if (form.__gs) return; form.__gs = true;
    var btn = form.querySelector('.gs-bundle__add');
    var priceEl = form.querySelector('[data-gs-bundle-price]');
    var err = form.querySelector('[data-gs-bundle-error]');
    function current() { return form.querySelector('input[type=radio]:checked') || form.querySelector('input[type=radio]'); }
    function sync() { var r = current(); if (r && priceEl) priceEl.textContent = r.getAttribute('data-price'); }
    form.addEventListener('change', sync); sync();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var r = current(); if (!r) return;
      var items = (r.getAttribute('data-items') || '').split(',').filter(Boolean).map(function (s) {
        var p = s.split(':'); return { id: Number(p[0]), quantity: Number(p[1]) };
      });
      if (!items.length) { err.textContent = 'Choose the bundle products in the theme editor first.'; err.hidden = false; return; }
      err.hidden = true; btn.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (data) { if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart'); return data; });
      }).then(function () {
        var code = r.getAttribute('data-code');
        if (code) { window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart'); return; }
        // Prestige listens for cart:refresh; UpCart (used on this store) has its own open call; fall back to the cart page.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
        if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); return; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') { drawer.show(); }
        else { window.location.href = root + 'cart'; }
      }).catch(function (ex) {
        err.textContent = ex.message; err.hidden = false;
      }).finally(function () { btn.disabled = false; });
    });
  }

  /* ---------- Reviews filter + show more ---------- */
  function initReviews(sec) {
    if (sec.__gs) return; sec.__gs = true;
    var limit = Number(sec.getAttribute('data-visible')) || 5;
    var cards = Array.prototype.slice.call(sec.querySelectorAll('.gs-review'));
    var chips = sec.querySelectorAll('.gs-chip');
    var more = sec.querySelector('[data-gs-more]');
    var topic = '', expanded = false;
    function render() {
      var shown = 0, matching = 0;
      cards.forEach(function (c) {
        var match = !topic || (' ' + c.getAttribute('data-topics') + ' ').indexOf(' ' + topic + ' ') > -1;
        if (match) matching++;
        var visible = match && (expanded || topic || shown < limit);
        if (visible) shown++;
        c.hidden = !visible;
      });
      if (more) more.hidden = expanded || !!topic || matching <= limit;
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        topic = chip.getAttribute('data-topic');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        render();
      });
    });
    if (more) more.addEventListener('click', function () { expanded = true; render(); });
    render();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-gs-bundle]').forEach(initBundle);
    (root || document).querySelectorAll('[data-gs-reviews]').forEach(initReviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  // Re-initialise when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
